import { IValidateParams } from './index';

export const validateOnlyNumbers = ({ value, isInteger = false, decimals = 18 }: IValidateParams): boolean => {
  const regexpTemplate = String.raw`^\d+(\.)?(\d{0,${decimals}})?$|^$`;
  if ((isInteger && !value.match(/^[+]?[1-9]\d*$/)) || value === '00') {
    return false;
  }
  return !(!value.match(regexpTemplate) || value === '00');
};
